import {ssrLazy} from 'ssr/lazy';

export const TextWithImageCarouselLazy = ssrLazy(() => import(/* webpackChunkName: "textWithImageCarousel" */ '../initTwi'));
